import { navigate } from "gatsby"
import { useCallback, useEffect } from "react"

import {
  marketingClient,
  useMutation,
  useQueryClient,
  userClient,
} from "@trueskin-web/apis"
import { useAuth } from "@trueskin-web/context"
import { Routes } from "@trueskin-web/translations"

import TypeformWidget from "../../components/typeform-widget"

const DataCheckQuestionnaire = ({ typeformUrl }) => {
  const queryClient = useQueryClient()

  const { user } = useAuth()

  const { mutateAsync: markDataCheckAsSubmitted } = useMutation(
    userClient.markDataCheckAsSubmitted
  )

  const onReady = useCallback(() => {
    marketingClient.sendEvent({
      name: marketingClient.EVENT_TYPES_ENUM.DATA_CHECK_Q_FORM_LOADED,
    })
  }, [])

  const onChange = useCallback((event) => {
    marketingClient.sendEvent({
      name: marketingClient.EVENT_TYPES_ENUM.DATA_CHECK_Q_QUESTION_OPENED,
      data: {
        label: event.ref,
      },
    })
  }, [])

  const onSubmit = useCallback(() => {
    const syncTypeform = async () => {
      await markDataCheckAsSubmitted()

      await queryClient.refetchQueries("dataCheck")

      navigate(Routes.App.Start.Photos.url, { replace: true })
    }

    marketingClient.sendEvent({
      name: marketingClient.EVENT_TYPES_ENUM.DATA_CHECK_Q_SUBMITTED,
    })

    syncTypeform()
  }, [queryClient, markDataCheckAsSubmitted])

  useEffect(() => {
    marketingClient.sendEvent({
      name: marketingClient.EVENT_TYPES_ENUM.DATA_CHECK_Q_PAGE_OPENED,
    })

    document.querySelector("body").style.overflow = "hidden"

    return () => {
      document.querySelector("body").style.overflow = ""
    }
  }, [])

  return (
    <div data-testid="web-portal-data-check-questionnaire">
      <TypeformWidget
        url={typeformUrl}
        hidden={{
          id: user._id,
        }}
        onReady={onReady}
        onSubmit={onSubmit}
        onQuestionChanged={onChange}
      />
    </div>
  )
}

export default DataCheckQuestionnaire
